import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { configure } from 'axios-hooks';
import Axios from 'axios';
import { FormContext } from './form-context';
import SignInForm from './forms/sign-in-form';
import SignUpForm from './forms/sign-up-form';
import EmailForm from './forms/email-form';
import DownloadForm from './forms/download-form';

// Configure the shared axios instance so we can accept cookies on sign-up or
// sign-in to get an authenticated session. This needs to be done before we use
// any of the axios-hooks.
configure({ axios: Axios.create() });

const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'stepToSignIn':
      return { ...state, step: 'signin' };
    case 'stepToSignUp':
      return { ...state, step: 'signup' };
    case 'stepToEmail':
      return { ...state, step: 'email' };
    case 'stepToDownload':
      return { ...state, step: 'download' };
    case 'setFirstName':
      return { ...state, firstName: payload };
    case 'setEmail':
      return { ...state, email: payload };
    default:
      throw new Error();
  }
};

export default function Form({ ebookName }) {
  const firstName = _.get(window, 'Livewire.currentUser.profile.firstName');
  const [state, dispatch] = React.useReducer(reducer, {
    step: firstName ? 'email' : 'signup',
    firstName,
    email: null,
  });
  const props = { ebookName };

  return (
    <FormContext.Provider value={{ state, dispatch }}>
      <React.Fragment>
        {state.step === 'signup' && <SignUpForm {...props} />}
        {state.step === 'signin' && <SignInForm {...props} />}
        {state.step === 'email' && <EmailForm {...props} />}
        {state.step === 'download' && <DownloadForm {...props} />}
      </React.Fragment>
    </FormContext.Provider>
  );
}

Form.propTypes = {
  ebookName: PropTypes.string.isRequired,
};
